import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { lenis } from "../global/scroll.js";

gsap.registerPlugin(ScrollTrigger);

export default class FooterHandler {
	init() {
		const toTopButton = document.querySelector('[data-id="to-top"]');
		if (!toTopButton) return;

		ScrollTrigger.create({
			start: "top -200", // Show after scrolling down 200px
			end: "max",
			onUpdate: (self) => {
				if (self.progress > 0) {
					gsap.to(toTopButton, {
						opacity: 1,
						pointerEvents: 'auto',
						ease: 'power2.out'
					});
				} else {
					gsap.to(toTopButton, {
						opacity: 0,
						pointerEvents: 'none',
						ease: 'power2.out'
					});
				}
			}
		});
		toTopButton.addEventListener('click', () => {
			lenis.scrollTo(0, {
				duration: 1.2,
				easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) // easeOutExpo
			});
		});
	}
}
